import React from "react";
import { Box } from "theme-ui";
import Search from "./Search";
import {ExpecSortingIndex, ExpecSortingList} from '../Expec_sorting';

const Expectations = ({version = ''}) => (
      <Box>
        <Search index={`${process.env.GATSBY_ALGOLIA_EXPEC_INDEX}`} sortingIndex={ExpecSortingIndex} sortingList={ExpecSortingList} version={version} />
      </Box>
);

export default Expectations;
